import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';

export const CMS_CONFIG_CHECKOUT = 'checkout';

export interface ICmsConfigCheckoutDataContent {
    creditCardExpiredMessage?: string;
}

ICmsContentService.registerConfig({
    id: CMS_CONFIG_CHECKOUT,
    name: 'Checkout Configuration',
    fields: [
        <NICmsContentField.IField>{
            key: 'sectionCreditCard',
            type: NICmsContentField.EFieldType.label,
            title: 'Credit Card'
        },
        <NICmsContentField.ITextField>{
            key: 'creditCardExpiredMessage',
            type: NICmsContentField.EFieldType.text,
            title: 'Expired message',
            default: 'This card has expired. Remove and another payment.'
        }
    ]
});
